import EntityGrid from '@/components/entity-grid/entity-grid';
import { type GridQueryOptions } from '@/interfaces';
import type { FilterSettings } from '@/models/filter-settings';
import { entityColumnsQueryOptions } from '@/queries/entityColumnsQueryOptions';
import { entityFieldsQueryOptions } from '@/queries/entityFieldsQueryOptions';
import { getEntityQueryOptions } from '@/queries/getEntityQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/$subCollection/',
)({
  component: RouteComponent
})

function RouteComponent() {
  const { module_id, entity_id, subCollection, entity_type_id } = Route.useParams();


  const { data: entityResult, isLoading } = useQuery(getEntityQueryOptions(entity_type_id, entity_id));
  const { data: fields, isLoading: fieldsLoading } = useQuery(entityFieldsQueryOptions(entity_type_id));
  const currentTab = entityResult?.view?.primaryTabs?.find(tab => tab.collection === subCollection);

  const currentField = fields?.find(field => field.collection === currentTab?.collection);

  if (isLoading || fieldsLoading) {
    return null;
  }

  if (!currentTab || !currentField?.foreignKey || !currentTab.collection) {
    console.error("Invalid tab or field configuration", { currentTab, currentField });
    return null;
  }

  return <SubGrid collection={currentTab.collection} module_id={module_id} parentId={entity_id} foreignKey={currentField.foreignKey} />
}


function SubGrid({ collection, module_id, parentId, foreignKey }: { collection: string, module_id: string, parentId?: string, foreignKey: string }) {

  const { data: columns } = useQuery(entityColumnsQueryOptions(collection));
  const queryOptions: GridQueryOptions = {
    moduleId: module_id,
    entityTypeId: collection,
    parentId: parentId,
    parentKeyField: foreignKey,

  };

  const filter: FilterSettings = {
    andOr: 'and',
    conditions: [
      {
        displayType: 'text-box',
        columnName: foreignKey,
        conditionStatement: 'is',
        value: parentId
      }
    ]
  };


  return <div className="h-full w-full ">
    <div style={{ width: "calc(100%-40px)", height: "98%" }} className="m-1 ">
      <EntityGrid
        moduleId={module_id}
        cols={columns ?? []}
        segmentId={parentId}
        queryOptions={queryOptions}
        filter={filter}
        widthOffset={380}
      />
    </div>
  </div>
}
